import angular from 'angular';
import STRINGS from 'Languages/korean';

(function() {
    'use strict';

    angular.module('app').factory('LanguageService', LanguageService);

    LanguageService.$inject = ['$http', '$q', '$rootScope', '$cacheFactory'];

    function LanguageService($http, $q, $rootScope, $cacheFactory) {
        const _STRINGS = {};

        for (const key in STRINGS) {
            _STRINGS[key] = '######';
        }

        return { strings: STRINGS };
    }
})();



// WEBPACK FOOTER //
// ./src/app/services/language.service.js